<template>
  <span>
       <v-row>
          <v-col cols="12" class="text-right">            

            <v-btn
              color="primary"
              outlined
              @click="listDialog= true;getListFromApi();"
            >
              See more investors
            </v-btn>               
          </v-col>                           
        </v-row>
          <!-- <v-icon @click="getListFromApi()" small dense>mdi-plus-circle-outline</v-icon> -->
          <v-dialog max-width="800px" v-model="listDialog">
              <v-card class="px-7" style="background: #121212;">
                <v-card-title>
                    {{title}}   
                    <v-spacer></v-spacer>
                    <v-btn color="primary" icon @click="listDialog = false">
                        <v-icon color="white" small>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-row>
                  <v-col cols="12">
                    <v-skeleton-loader v-if="listLoad" type="table"></v-skeleton-loader>
                    <v-simple-table v-if="!listLoad">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left"></th>
                            <th class="text-left">Name</th>
                            <th class="text-right">Days <br> <span class="text-no-wrap"> To Trade </span> </th>
                            <th class="text-center">Similarity <span class="text-no-wrap"> with you </span></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, i) in items" :key="i">
                            <td>
                              <v-btn
                                class="px-2 mr-2"
                                color="primary"
                                min-width="0"
                                icon
                                small
                                @click="goToInvestor(item.id)"
                              >
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on }">
                                    <v-icon v-on="on">
                                      mdi-magnify-plus-outline
                                    </v-icon>                        
                                  </template>
                                  <span>Analyze</span>
                                </v-tooltip> 
                              </v-btn>
                            </td>                         
                            <td>
                              <div class="text-no-wrap"> 
                                {{ item.investor }}
                              </div>
                              <div class="caption grey--text">
                                {{ item.classification }}
                              </div>
                            </td>
                            <td class="text-right">{{ item.daystotrade }}</td>
                            <td class="text-center">
                              <v-progress-circular :size="40" color="pink" :value="getSimilarity(item.similarity)">
                                <strong class="similarity-text"> {{ item.similarity }} </strong>
                              </v-progress-circular>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
                <v-card-actions>    
                  <v-spacer></v-spacer>             
                  <v-btn color="primary" text @click="listDialog = false">Close</v-btn>
                </v-card-actions>
              </v-card>                
          </v-dialog>
    </span>
</template>

<script>
  export default {
    name: 'StockAnalyzeComponentLikeInvestorsExpand',
    props: ['stock','endpoint','title'],     
    data() {
      return {
        items: [
        ],
        listLoad: true,
        errorbar: false,
        listDialog: false,           
      }
    },      
    methods: { 
      goToInvestor(id) {
        this.$router.push({ name: 'InvestorsAnalyze', params: { investor: id } });
      },           
      async getListFromApi() {
        var self = this
        const currentSession = await this.$Amplify.Auth.currentSession()
        const currentToken = currentSession.getIdToken().getJwtToken()
        this.$http.get(process.env.VUE_APP_API_HOST + self.endpoint + self.stock + '/200',{
          headers: {
            'Authorization': currentToken,
            'Content-Type': 'application/json'
          }
        }).then(function (response) {
          //console.log(response.data)
          self.items = response.data 
          self.listLoad = false
        }).catch(function (/*error*/) {
          //console.log(error)
          self.listLoad = false
          //self.errorbar = true
        })
      },
      getSimilarity (similarity) {
        if (similarity.includes('%')) {
          return similarity
        } else {
          return 0
        }
      }
    },
    watch: {
      '$route' () {
        this.getListFromApi()
      }
    }
  }
</script>